var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import mutationVariables from '../utility/mutationVariables';
import { ChartConfigurationDocument, UpdateChartDocument, } from '../generated/graphql';
var useUpdateChart = function (chartId, defaultConfiguration) {
    var _a = useState(), configuration = _a[0], setConfiguration = _a[1];
    var _b = useState(), currentConfiguration = _b[0], setCurrentConfiguration = _b[1];
    var _c = useState(false), newBreakdownError = _c[0], setNewBreakdownError = _c[1];
    var _d = useLazyQuery(ChartConfigurationDocument, {
        variables: { id: chartId },
    }), getChartConfiguration = _d[0], configurationData = _d[1].data;
    var _e = useMutation(UpdateChartDocument), updateChartMutation = _e[0], _f = _e[1], data = _f.data, processing = _f.loading;
    useEffect(function () {
        if (defaultConfiguration) {
            var frequencyId = defaultConfiguration.frequencyId, conf = __rest(defaultConfiguration, ["frequencyId"]);
            setCurrentConfiguration(conf);
            setConfiguration(conf);
        }
        if (configurationData && configurationData.chartConfiguration) {
            var _a = configurationData.chartConfiguration, frequencyId = _a.frequencyId, conf = __rest(_a, ["frequencyId"]);
            setCurrentConfiguration(conf);
            setConfiguration(conf);
        }
    }, [defaultConfiguration, configurationData]);
    var updateChart = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateChartMutation(mutationVariables(configuration))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChartName = function (event) {
        setConfiguration(__assign(__assign({}, configuration), { name: event.target.value }));
    };
    var handleDataset = function (event, key) {
        var _a;
        var datasets = (_a = configuration.measures) === null || _a === void 0 ? void 0 : _a.map(function (dataset) {
            var _a;
            if (dataset.type + dataset.rowId === event.target.name) {
                return __assign(__assign({}, dataset), (_a = {}, _a[key] = key === 'percentage' ? event.target.checked : event.target.value, _a));
            }
            return dataset;
        });
        setConfiguration(__assign(__assign({}, configuration), { measures: datasets }));
    };
    var handleBreakdown = function (event, key) {
        var _a;
        var _b, _c, _d, _e;
        var breakdowns;
        if (event.target.name === 'new') {
            var isDuplicate = (_b = configuration.breakdowns) === null || _b === void 0 ? void 0 : _b.some(function (breakdown) { return breakdown.breakdownId === event.target.value; });
            var isNew = (_c = configuration.breakdowns) === null || _c === void 0 ? void 0 : _c.every(function (breakdown) { return 'id' in breakdown; });
            if (isDuplicate) {
                setNewBreakdownError(true);
                breakdowns = configuration.breakdowns;
            }
            if (isNew) {
                setNewBreakdownError(false);
                breakdowns = __spreadArrays(configuration.breakdowns, [(_a = {}, _a[key] = event.target.value, _a)]);
            }
            if (!isDuplicate && !isNew) {
                breakdowns = (_d = configuration.breakdowns) === null || _d === void 0 ? void 0 : _d.map(function (breakdown) {
                    var _a;
                    if (!('id' in breakdown)) {
                        return _a = {}, _a[key] = event.target.value, _a;
                    }
                    return breakdown;
                });
            }
        }
        else {
            breakdowns = (_e = configuration.breakdowns) === null || _e === void 0 ? void 0 : _e.map(function (breakdown) {
                var _a;
                if (breakdown.breakdownId === event.target.name) {
                    return __assign(__assign({}, breakdown), (_a = {}, _a[key] = event.target.value, _a));
                }
                return breakdown;
            });
        }
        setConfiguration(__assign(__assign({}, configuration), { breakdowns: breakdowns }));
    };
    return {
        data: data,
        processing: processing,
        configuration: configuration,
        currentConfiguration: currentConfiguration,
        getChartConfiguration: getChartConfiguration,
        updateChart: updateChart,
        handleChartName: handleChartName,
        handleDataset: handleDataset,
        handleBreakdown: handleBreakdown,
        newBreakdownError: newBreakdownError,
    };
};
export default useUpdateChart;
